<template>
  <span>
    <span v-if="!textOnly">
      <template v-if="paymentType === 'CREDIT_CARD'">
        <v-icon
          color="secondary"
          class="i-payment-icon"
          v-tooltip="'Card Services'"
          >mdi-credit-card-outline
        </v-icon>
      </template>
      <template v-else-if="paymentType === 'PAYMENT_SERVICES'">
        <v-icon
          color="primary"
          class="i-payment-icon i-payment-icon-primary"
          v-tooltip="'Payment Services'"
          >mdi-cash-clock
        </v-icon>
      </template>
      <template v-else-if="paymentType === 'SUPPLIER_DIRECT'">
        <v-icon
          color="primary"
          class="i-payment-icon i-payment-icon-primary"
          v-tooltip="'Supplier Direct'"
          >mdi-handshake-outline
        </v-icon>
      </template>
    </span>
    <span v-else>
      <template v-if="paymentType === 'CREDIT_CARD'">Card Services</template>
      <template v-else-if="paymentType === 'PAYMENT_SERVICES'"
        >Payment Services</template
      >
      <template v-else-if="paymentType === 'SUPPLIER_DIRECT'"
        >Supplier Direct</template
      >
      <template v-else>Unknown</template>
    </span>
  </span>
</template>

<script>
export default {
  props: {
    paymentType: {
      type: String,
      required: true
    },
    textOnly: {
      type: Boolean,
      required: false
    }
  },

  data: () => ({})
}
</script>

<style scoped></style>
